// /src/components/donate/KofiEmbedPanel.jsx

import React, { useEffect, useState } from 'react';
import axios from 'axios';

const KOFI_PAGE_URL = 'https://ko-fi.com/pallas_invictus';
const KOFI_EMBED_URL =
  'https://ko-fi.com/pallas_invictus/?hidefeed=true&widget=true&embed=true&preview=true';
const PROBE_TIMEOUT_MS = 10000;

async function probeKofiReachable(signal) {
  try {
    const res = await axios.get('/api/public/kofi-embed-health', {
      timeout: PROBE_TIMEOUT_MS,
      signal,
    });
    return Boolean(res?.data?.ok);
  } catch (error) {
    if (
      signal?.aborted
      || error?.code === 'ERR_CANCELED'
      || error?.name === 'CanceledError'
      || axios.isCancel?.(error)
    ) {
      return null;
    }
    return false;
  }
}

export default function KofiEmbedPanel() {
  const [status, setStatus] = useState('checking');
  const [retryKey, setRetryKey] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    // Set checking synchronously in the effect body so it paints before the probe awaits.
    setStatus('checking');
    (async () => {
      const ok = await probeKofiReachable(controller.signal);
      if (controller.signal.aborted || ok == null) return;
      setStatus(ok ? 'ready' : 'down');
    })();
    return () => {
      controller.abort();
    };
  }, [retryKey]);

  return (
    <div className="ko-fi-panel-wrap">
      {status === 'checking' ? (
        <p className="ko-fi-panel__loading" role="status">
          Checking Ko-fi donation widget…
        </p>
      ) : null}

      {status === 'down' ? (
        <div
          className="ko-fi-panel ko-fi-panel--unavailable"
          role="status"
          data-resource="public.donation-panel"
          data-action="read"
          data-route="/api/public/kofi-embed-health"
          data-description="Ko-fi embed unavailable notice"
        >
          <p className="ko-fi-panel__down-title">Ko-fi is temporarily unavailable</p>
          <p className="ko-fi-panel__down-text">
            The donation widget is hosted by Ko-fi.com and cannot be loaded right now.
            This comes from their side, not from our site. Please try again later.
          </p>
          <div className="ko-fi-panel__down-actions">
            <button
              type="button"
              className="ko-fi-panel__down-retry"
              onClick={() => {
                setStatus('checking');
                setRetryKey((key) => key + 1);
              }}
              data-resource="public.donation-panel"
              data-action="read"
              data-route="/api/public/kofi-embed-health"
            >
              Try again
            </button>
            <a
              href={KOFI_PAGE_URL}
              className="ko-fi-panel__down-link"
              target="_blank"
              rel="noopener noreferrer"
              data-resource="public.donation-panel"
              data-action="read"
            >
              Open Ko-fi in a new tab
            </a>
          </div>
        </div>
      ) : null}

      {status === 'ready' ? (
        <iframe
          id="kofiframe"
          key={retryKey}
          src={KOFI_EMBED_URL}
          className="ko-fi-panel"
          title="pallas_invictus"
        />
      ) : null}
    </div>
  );
}
